var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import Sheet from 'sheet-happens';
import { Method, requestContext } from '../../../data/rest/api';
import { useTagContext } from '../../../data/tag/tagContext';
import useTableCells from '../../../hooks/useTableCells';
import { ArrowDown, ArrowUp, getIconAsHTMLImageElement } from '../../../shared/icons/icons';
import Modal from '../../../shared/modal/Modal';
import ModalHeader from '../../../shared/modal/ModalHeader';
import { Loading } from '../../../styled/Basic';
import { ModalBody } from '../../../styled/Modal';
var KEY = ['stats'];
function getStats() {
    return __awaiter(this, void 0, void 0, function () {
        var req, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req = { method: Method.GET, headers: new Headers() };
                    return [4 /*yield*/, requestContext.initializeRequest(req)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetch('api/v3/evaluator/stats', req)];
                case 2:
                    res = _a.sent();
                    if (res.status >= 400 && res.status < 600) {
                        throw res;
                    }
                    return [2 /*return*/, res.json()];
            }
        });
    });
}
function DatabaseStatisticsModal() {
    var tagData = useTagContext().tagData;
    var _a = __read(useState([]), 2), sortOrder = _a[0], setSortOrder = _a[1];
    var _b = useTableCells([170, 170, 170, 170, 170]), onCellWidthChange = _b.onCellWidthChange, cellWidth = _b.cellWidth;
    var _c = __read(useState(), 2), sorted = _c[0], setSorted = _c[1];
    var data = useQuery(KEY, getStats, {
        notifyOnChangeProps: ['data'],
        select: function (data) {
            var e_1, _a;
            var fullAccTagStats = [];
            try {
                for (var _b = __values(tagData.accountTags), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var accTag = _c.value;
                    var stat = data.accountTagStats[accTag.id];
                    var duration = stat === null || stat === void 0 ? void 0 : stat.accountTagCalculatedEvents.reduce(function (duration, event) {
                        return (duration +
                            event.bTreeIndexUpdateDuration +
                            event.calculationDuration +
                            event.stageInitializationDuration);
                    }, 0);
                    fullAccTagStats.push(__assign(__assign({ tag: accTag }, stat), { summedDuration: duration }));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return __assign(__assign({}, data), { fullAccTagStats: fullAccTagStats });
        },
    }).data;
    var columns = [
        {
            title: 'Name',
            data: function (stat) {
                return stat === null || stat === void 0 ? void 0 : stat.tag.name;
            },
            sort: function (a, b) {
                var order = a.tag.name.localeCompare(b.tag.name);
                return order;
            },
        },
        {
            title: 'Summed Duration (ms)',
            data: function (stat) {
                var _a;
                return (_a = stat === null || stat === void 0 ? void 0 : stat.summedDuration) !== null && _a !== void 0 ? _a : '';
            },
            sort: function (a, b) {
                return a.summedDuration - b.summedDuration;
            },
        },
        {
            title: 'Cell Count',
            data: function (stat) {
                return stat === null || stat === void 0 ? void 0 : stat.cellCount;
            },
            sort: function (a, b) {
                return a.cellCount - b.cellCount;
            },
        },
        {
            title: 'Combos',
            data: function (stat) {
                var _a, _b, _c;
                return ((_c = (_b = (_a = stat === null || stat === void 0 ? void 0 : stat.accountTagCalculatedEvents) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.combosEvents.filter(function (e) { return !!tagData.tagById[e.accountTagId]; }).map(function (e) {
                    var accTag = tagData.tagById[e.accountTagId];
                    return accTag.name + '=' + e.combinationsGenerated;
                }).join(', ')) !== null && _c !== void 0 ? _c : '');
            },
        },
        {
            title: 'Fill Data',
            data: function (stat) {
                var _a, _b, _c;
                return ((_c = (_b = (_a = stat === null || stat === void 0 ? void 0 : stat.accountTagCalculatedEvents) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.fillDataEvents.filter(function (e) { return !!tagData.tagById[e.accountTagId]; }).map(function (e) {
                    var accTag = tagData.tagById[e.accountTagId];
                    return accTag.name;
                }).join(', ')) !== null && _c !== void 0 ? _c : '');
            },
        },
    ];
    var resultSet = data ? (sorted ? sorted : data === null || data === void 0 ? void 0 : data.fullAccTagStats) : [];
    function handleData(x, y) {
        var _a, _b;
        return "".concat((_b = (_a = columns[x]) === null || _a === void 0 ? void 0 : _a.data(resultSet[y])) !== null && _b !== void 0 ? _b : '');
    }
    function handleSort(sortData) {
        var target = sortOrder.find(function (o) { return o.x === sortData.x; });
        var newSortOrder;
        if (!target) {
            newSortOrder = __spreadArray(__spreadArray([], __read(sortOrder), false), [sortData], false);
        }
        else {
            var result = sortOrder.filter(function (c) { return c.x !== sortData.x; });
            newSortOrder = __spreadArray(__spreadArray([], __read(result), false), [sortData], false);
        }
        var sortedCopy = __spreadArray([], __read(resultSet), false);
        sortedCopy.sort(function (a, b) {
            var order = 0;
            for (var i = newSortOrder.length - 1; i >= 0; i--) {
                var sort = newSortOrder[i];
                var sortCriteria = columns[sort.x].sort;
                if (sortCriteria) {
                    var currentOrder = sortCriteria(a, b);
                    order = order || (sort.direction === 'ASC' ? currentOrder * -1 : currentOrder);
                }
            }
            return order;
        });
        setSortOrder(newSortOrder);
        setSorted(sortedCopy);
    }
    function handleColumnHeaders(x) {
        var column = columns[x];
        if (!column) {
            return '';
        }
        var cell = { items: [] };
        cell.items.push({
            x: 0,
            y: 0,
            content: column.title,
            horiozntalAlign: 'left',
        });
        if (!column.sort) {
            return cell;
        }
        var sortData = sortOrder.find(function (so) { return so.x === x; });
        if ((sortData === null || sortData === void 0 ? void 0 : sortData.direction) !== 'DESC') {
            cell.items.push({
                x: 0,
                y: -7,
                width: 20,
                height: 20,
                horiozntalAlign: 'right',
                content: getIconAsHTMLImageElement(React.createElement(ArrowDown, null)),
                onClick: function () {
                    handleSort({ x: x, direction: 'DESC' });
                },
            });
        }
        if ((sortData === null || sortData === void 0 ? void 0 : sortData.direction) !== 'ASC') {
            cell.items.push({
                x: 5,
                y: -12,
                width: 20,
                height: 20,
                horiozntalAlign: 'right',
                content: getIconAsHTMLImageElement(React.createElement(ArrowUp, null)),
                onClick: function () {
                    handleSort({ x: x, direction: 'ASC' });
                },
            });
        }
        return cell;
    }
    return (React.createElement(Modal, { width: 900, height: 600 },
        React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(ModalHeader, { title: "Database Statistics" }),
            React.createElement(ModalBody, { style: { flex: '1 1 auto' } }, data ? (React.createElement(Sheet, { readOnly: true, cellWidth: cellWidth, editData: handleData, sourceData: handleData, displayData: handleData, columnHeaders: handleColumnHeaders, onCellWidthChange: onCellWidthChange })) : (React.createElement(Loading, null))))));
}
export default DatabaseStatisticsModal;
